var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2023Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299.79 299.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 149.9,
    cy: 149.9,
    r: 129.9,
    style: {
      fill: "#fff",
      stroke: "#5cc3b0",
      strokeMiterlimit: 10,
      strokeWidth: 40
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.33,138.6h0c-1.3-1.15-3-1.72-4.73-1.58l-6.52-.02c-.59,0-1.18,.11-1.73,.32l-4.11,.74c-2.11,.38-4.13,1.14-5.97,2.25-1.5,.91-3.05,1.88-3.32,2.12l-41.33,36.66c-.99,.88-2.48,.88-3.46,0l-41.33-36.66c-.27-.24-1.81-1.21-3.32-2.12-1.83-1.11-3.86-1.87-5.97-2.25l-4.11-.74c-.55-.21-1.14-.32-1.73-.32l-6.52,.02c-1.73-.14-3.43,.43-4.73,1.58h0c-2.76,2.44-4.34,5.94-4.34,9.63v24.14c0,4.03,2.38,7.68,6.06,9.3l8.26,3.65c1.75,.77,3.65,1.18,5.56,1.18h107.78c1.92,0,3.81-.4,5.56-1.18l8.26-3.65c3.68-1.63,6.06-5.28,6.06-9.3v-24.14c0-3.68-1.58-7.19-4.34-9.63Z",
    style: {
      fill: "#5cc3b0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.83,
    y1: 87.7,
    x2: 269.35,
    y2: 87.7,
    style: {
      fill: "none",
      stroke: "#5cc3b0",
      strokeMiterlimit: 10,
      strokeWidth: 30
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2023Logo);
export default __webpack_public_path__ + "static/media/2023logo.d8305523dc0f7462e2b3b96230ede4d1.svg";
export { ForwardRef as ReactComponent };